import SEO from './../utils/SEOMetaTags'

import './../scss/PageNotFound.scss'

export default function PageNotFound({ message = null, page = {name: 'home', path: '/'} }) {
    return (
        <content-constrainer class="content-constrainer--no-border content-constrainer--lead-container">
            <div className="page-not-found">
                <SEO 
                    title="Page Not Found | Laff"
                    description="The URL could not be found"
                    robots="noindex"
                />
                <section className="page-not-found__section">                
                    <h1 className='h2 page-not-found__header'>Sorry, this page isn't available</h1>
                    <div className="page-not-found__message">
                        { (message === null) && 
                            <>If you followed a link it may be broken, or the page may have been removed.</> 
                        }
                        { (message !== null) && 
                            <>{message}</>
                        }
                    </div>
                    <div className="page-not-found__link">
                        Go to the <a href={page.path}> {page.name} page.</a>
                    </div>
                    { (page.name !== 'home') && 
                        <div className='page-not-found__link'>
                            Go to Laff's <a href="/"> home page.</a>
                        </div> 
                    }
                </section>
            </div>
        </content-constrainer>
    )
}
